<template>
    <section v-if="hasPermissions(['Budgeting-Staffing-Fixed Read', 'Budgeting-Staffing-Fixed Write'])" class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1" v-html="title_page"/>
        <div class="view__description">
            <p class="view__description__text">
                Use the Wizard to add Rooms to the Fixed Data or click Add Fixed to create a new fixed line item.
            </p>
        </div>

        <div class="bar-container">
            <div class="bar-container__search-bar">
                <div class="input-field my-0" v-if="fixeds.length &&  hasPermissions(['Budgeting-Staffing-Fixed Read'])">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
            <div v-if="hasPermissions(['Budgeting-Staffing-Fixed Write'])" class="bar-container__options">
                <button :href="'#'" @click="go_wizzard()" class="modal__buttons__item button__modal d-inline" style="background-color: #ffff; border: 1.4px solid #008AD8; color: #008AD8; width: 109px">
                        Wizard
                    <i class="prefix">
                        <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px;">
                    </i>
                </button>
                <button class="modal__buttons__item w-auto px-3" v-html="'Mass Delete'" :class="{'disabled button__disabled' : !selected}" :disabled="!selected" @click="massive_modal_delete()"/>
                <a class="modal__buttons__item w-auto px-3" :href="`/budgeting-staffing-scenario/update/${this.$route.params.id}`" v-html="'Back to Scenario'"/>
                <a class="modal__buttons__item w-auto px-3" :href="`/budgeting-staffing-variable/${this.$route.params.id}`" v-html="'Edit Variable Items'"/>
            </div>
            <div class="bar-container__cta" v-if="hasPermissions(['Budgeting-Staffing-Fixed Write'])">
                <span class="button__modal d-inline float-right">
                    <button href="#" @click="form_modal()" class="modal__buttons__item button__modal d-inline" style="background-color: #ffff; border: 1.4px solid #008AD8; color: #008AD8; width: 109px">
                        {{ add_btn }}
                        <i class="prefix ml-1">
                            <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                        </i>
                    </button>
                </span>
            </div>
        </div>

        <div class="tab-content" v-show="fixeds.length && hasPermissions(['Budgeting-Staffing-Fixed Read'])">
            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0">
                    <div class="col-lg-12">  
                        <div class="table-responsive table-fix-head" style="max-height: 35rem;">
                            <table>
                                <thead>
                                    <tr>
                                        <th slot="header" scope="col">
                                            <span class="custom-control custom-checkbox">
                                                <input :id="`theadcheck`" v-model="select_all" type="checkbox" class="custom-control-input"/>
                                                <label :for="`theadcheck`" class="custom-control-label ml-2"/>
                                            </span>
                                        </th>
                                        <th scope="col" class="header-item">
                                            <span style="margin-left: 5px;" v-html="'Detail'"/>
                                                <!-- <img :src="`/assets/img/svg/update_entry.svg`" style="width:15px;" alt="Update Entry Icon"/>
                                            </span> -->
                                        </th>
                                        <th scope="col" v-for="(val, i) in table_headers" :key="i" v-html="val.text" />
                                    </tr>
                                </thead>
                                <draggable v-model="fixeds" tag="tbody" @start="drag=true" @end="drag=false" @change="updateOrd()">
                                    <tr v-for="(val, i) in fixeds" :key="i" :class="val.status ? 'table-primary' : ''">
                                        <td scope="col">
                                            <span class="custom-control custom-checkbox">
                                                <input :id="`checkAll${i}`" type="checkbox" class="custom-control-input" v-model="val.checked"/>
                                                <label :for="`checkAll${i}`" class="custom-control-label ml-2"/>
                                            </span>
                                        </td>
                                        <td scope="col">
                                            <a 
                                                class="bold-text"
                                                style="color: #039be5; text-decoration: none;"
                                                @click="modal_update(i)"
                                            >
                                                <span style="margin-left: 5px;">
                                                    <img :src="`/assets/img/svg/update_entry.svg`" style="width:15px;" alt="Update Entry Icon"/>
                                                </span>
                                            </a>
                                        </td>
                                        <th scope="row" v-html="i + 1"/>
                                        <td v-html="val.group"/>
                                        <td v-html="val.description"/>
                                        <td v-html="val.frequency_week"/>
                                        <td v-html="val.daily_minutes_to_show"/>
                                        <td v-html="val.annual_minutes_to_show"/>
                                        <td>
                                            <span v-if="val.wizzard" class="badge badge-danger text-white" v-html="'No'" style="font-size: 12px"/>
                                            <span v-else class="badge badge-success text-white" v-html="'Yes'" style="font-size: 12px"/>
                                        </td>
                                    </tr>
                                </draggable>
                            </table>
                        </div>    
                    </div>
                </div>
            </div>
        </div>

        <DeletionModal 
            :single_object="single_object" 
            :global_index="global_index" 
            @objectDeletion="object_deletion_child(rest_api_child,$event)"
        />

        <DeletionMassiveModal
            @objectDeletion="massive_local_emition($event)"
        />

        <FormModal 
            :title="'New Fixed'"
            :breadcrumb="breadcrumb"
            :parent_id="parent_id"
            :rest_api="rest_api_child"
            :notyf="notyf"
            :axios="axios"
            :maximum_order="fixeds.length"
            :array_options="array_options"
            @unshiftObject="unshift_object($event)"
            @updateArrayOptions="updateArrayOptions($event)"
            @updateBackupDailyAssignments="updateBackupDailyAssignments($event)"
        />

        <UpdateModal 
            :title="'Fixed Update'"
            :breadcrumb="breadcrumb"
            :parent_id="parent_id"
            :rest_api="rest_api_child"
            :notyf="notyf"
            :axios="axios"
            :single_object="single_object"
            :maximum_order="fixeds.length"
            :global_index="global_index"
            :array_options="array_options"
            @spliceObject="splice_object($event)"
            @updateArrayOptions="updateArrayOptions($event)"
            @updateBackupDailyAssignments="updateBackupDailyAssignments($event)"
            ref="update_modal_ref"
        />

        <WaitingModal/>

    </section>
</template>

<script>
import axios                from    'axios';
import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal         from    '@/components/WaitingModal'
import Resources            from    './detail_resources'
import FormModal            from    './FormModal'
import UpdateModal          from    './UpdateModal'
import DeletionModal        from    '@/components/DeletionModal'
import DeletionMassiveModal from    '@/components/DeletionMassiveModal'
import draggable            from    'vuedraggable'
import 'vuetify/dist/vuetify.min.css'

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});
export default {
    name: 'StaffingScenariosDetail',

    components: {
      Breadcrumb,
      WaitingModal,
      DeletionModal,
      FormModal,
      UpdateModal,
      DeletionMassiveModal,
      draggable
    },

    data() {
        return {
            notyf,
            axios,
            scenario_id:            this.$route.params.id,
            parent:                 {},
            parent_id:              '',
            title_page:             'Staffing Fixed',
            rest_api:               `staffing_scenarios/${this.$route.params.id}`,
            rest_api_child:         `staffing_fixed`,
            table_headers:          Resources.table_headers,
            breadcrumb:             Resources.breadcrumb,
            add_btn:                'Add Fixed',
            single_select:          false,
            table_selection:        [],
            search:                 '',
            global_index:           '',
            single_object:          {},
            fixeds:                 [],
            array_options:          {},
            select_ids:             [],
            select_all:             false
        }
    },

    methods: {

        go_wizzard()
        {
            var confirm = window.confirm("Using the wizzard to add new fixed items will delete your old fixed items. Are you sure you want to run the wizzard?")

            if(confirm)
            {
                window.location.href=`/budgeting-staffing-scenario/wizzard/${this.scenario_id}`
            }
        },

        unshift_object(new_object)
        {
            this.fixeds.splice((new_object.order - 1), 0, new_object)
            this.updateOrd(true)
        },

        splice_object(splicing_object)
        {
            this.fixeds.splice(splicing_object.index, 1, {...splicing_object.single_object, shift_class: ''})
            this.updateOrd(true)
        },

        form_modal()
        {
            window.$('#static').modal('show')
        },

        modal_deletion(index)
        {
            this.global_index  = index
            this.single_object = this.fixeds[index]
            window.$('#static-deletion').modal('show')
        },

        modal_update(index)
        {
            this.$refs.update_modal_ref.setup()
            this.global_index  = index
            this.single_object = this.fixeds[index]
            this.single_object.updated_date = this.date;

            console.log(this.single_object);
            
            window.$('#static-update').modal('show')
        },

        fill_data(data)
        {
            this.parent     = data.scenario
            this.parent_id  = data.parent_id
            this.fixeds     = data.fixeds
            this.array_options = {
                group_id: data.groups,
                shift_class: data.shift_class,
                daily_assignment_id: []
            }
            this.breadcrumb.push({
                name:   this.parent.scenario,
                href:   '#',
                arrow:  "",
            })
        },

        updateArrayOptions({daily_assignment_id})
        {
            this.array_options = {...this.array_options, daily_assignment_id}
        },

        updateBackupDailyAssignments({daily_assignments})
        {
            this.array_options = {...this.array_options, daily_assignments}

            console.log('array_options', this.array_options);
        },

        async updateOrd(applyDefaultSort = false)
        {
            if(applyDefaultSort)
            {
                let newData = this.fixeds

                // const compareFunction = (a, b) => 
                // {
                //     if (a.group < b.group) return -1;
                //     if (a.group > b.group) return 1;
                    
                //     return a.frequency_week - b.frequency_week;
                // };

                // newData.sort(compareFunction);

                let orderNumber = 1;
                // let currentGroup = newData[0].group
                newData.forEach((item, index) => 
                {
                    // if (item.group !== currentGroup) {
                    //     currentGroup = item.group;
                    //     orderNumber = 1;
                    // }

                    newData[index].order = orderNumber;
                    orderNumber++;
                })
            }

            const form_data = {
                table: 'staffing_fixeds',
                data: this.fixeds
            }
            const data = await this.postingByPost('general_functions/post_dragging', form_data)
            this.fixeds = data.data;

        },

        trashing(index)
        {
            this.fixeds.splice(index, 1)
        },

        massive_modal_delete()
        {
            this.select_ids = this.fixeds.filter(item => item.checked).map(item => item.id)
            if(this.select_ids.length)
            {
                window.$('#static-deletion-massive').modal('show')
            }
        },

        async massive_local_emition()
        {
            let json_request = {
                id:         this.select_ids,
                massive:    true,
            }

            const rest_api_temp = this.rest_api;
            this.rest_api = this.rest_api_child;
            let sendingMassive = await this.massive_deletion(json_request)
            this.rest_api = rest_api_temp
            if(sendingMassive)
            {
                this.select_ids.forEach( item =>
                {
                    const index = this.fixeds.findIndex(value => value.id == item)
                    if(index > -1)
                    {
                        this.fixeds.splice(index, 1)
                    }
                })
                this.select_ids = []  
            }
        },
    },
    
    async mounted()
    {
       if(this.hasPermissions(['Budgeting-Staffing-Fixed Read', 'Budgeting-Staffing-Fixed Write']))
        {
            await this.api_request()
        }
        else
        {
            window.location.href = '/'
        }
    },

    computed:
    {
        selected()
        {
            const bool = this.fixeds.filter(item => item.checked)
            return Boolean(bool.length)
        }
    },
    watch: {
        async 'select_all' (val)
        {
            this.fixeds.map(item => item.checked = val)
        }
    }
}

</script>